import { io } from "socket.io-client";

const socket =io('https://arjd-live-api.onrender.com/',{
  reconnection:false
});

export default socket;